import { render, staticRenderFns } from "./OrderInvalidatedByProvider.vue?vue&type=template&id=0ff5dd8c"
import script from "./OrderInvalidatedByProvider.vue?vue&type=script&lang=js"
export * from "./OrderInvalidatedByProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports